import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { MAX_REVIEW_DESCRIPTION_LENGTH } from '../../../../constants/questions';
import { Col, Row } from 'reactstrap';
import { Button } from '../../../../components/elements/buttons/Button';
import { HideQuestionButtonIcon } from '../../../../components/elements/icons/Icons';
import './styles.css';

const CreateReviewForm = ({ onPublish, onClose }) => {
    const [text, setText] = useState('');

    const handleTextChange = useCallback(e => {
        const value = e.target.value;

        if (MAX_REVIEW_DESCRIPTION_LENGTH >= value.length) {
            setText(value);
        }
    }, []);

    const handlePublishButtonClick = useCallback(() => {
        onPublish(text);
    }, [text, onPublish]);

    return (
        <div className="post__create-review">
            <div className="form-group">
                <textarea
                    name="text"
                    rows={4}
                    className="form-control"
                    placeholder="Review"
                    value={text}
                    onChange={handleTextChange}
                />
            </div>
            <div className="form-group">
                <Row className="post__create-review-donate">
                    <Col md={7} />
                    <Col md={5}>
                        <Button
                            classes="btn btn-outline-primary"
                            title="Publish"
                            onClick={handlePublishButtonClick}
                        />
                    </Col>
                </Row>
            </div>
            <div className="w-100 justify-content-center">
                <div className="hide-question-button" onClick={onClose}>
                    <HideQuestionButtonIcon />
                </div>
            </div>
        </div>
    );
};

CreateReviewForm.propTypes = {
    onPublish: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default React.memo(CreateReviewForm);
